__turbopack_context__.v({
  "allLink": "FeaturedAnnouncementsSection-module__moNvVG__allLink",
  "card": "FeaturedAnnouncementsSection-module__moNvVG__card",
  "cardArrow": "FeaturedAnnouncementsSection-module__moNvVG__cardArrow",
  "cardBody": "FeaturedAnnouncementsSection-module__moNvVG__cardBody",
  "cardStatic": "FeaturedAnnouncementsSection-module__moNvVG__cardStatic",
  "cardText": "FeaturedAnnouncementsSection-module__moNvVG__cardText",
  "cardTitle": "FeaturedAnnouncementsSection-module__moNvVG__cardTitle",
  "container": "FeaturedAnnouncementsSection-module__moNvVG__container",
  "emptyBody": "FeaturedAnnouncementsSection-module__moNvVG__emptyBody",
  "emptyEyebrow": "FeaturedAnnouncementsSection-module__moNvVG__emptyEyebrow",
  "emptyState": "FeaturedAnnouncementsSection-module__moNvVG__emptyState",
  "emptyTitle": "FeaturedAnnouncementsSection-module__moNvVG__emptyTitle",
  "eyebrow": "FeaturedAnnouncementsSection-module__moNvVG__eyebrow",
  "footerAction": "FeaturedAnnouncementsSection-module__moNvVG__footerAction",
  "heading": "FeaturedAnnouncementsSection-module__moNvVG__heading",
  "image": "FeaturedAnnouncementsSection-module__moNvVG__image",
  "imageFrame": "FeaturedAnnouncementsSection-module__moNvVG__imageFrame",
  "imageFrameEmpty": "FeaturedAnnouncementsSection-module__moNvVG__imageFrameEmpty",
  "list": "FeaturedAnnouncementsSection-module__moNvVG__list",
  "section": "FeaturedAnnouncementsSection-module__moNvVG__section",
  "subtitle": "FeaturedAnnouncementsSection-module__moNvVG__subtitle",
  "title": "FeaturedAnnouncementsSection-module__moNvVG__title",
});
